<template>
<div>
    <el-upload
        class="rp-messenger-drag-drop-file-uploader"
        drag
        :action="getUrl()"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :on-error="handleError"
        :on-progress="handleProgress"
        :file-list="fileList"
        :show-file-list="false"
        :data="getUploadProps()"
        name="0"
        ref="rpUplodFiles"
        multiple>
        <i class="el-icon-bottom"></i>
        <div class="rp-drag-drop-file-uploader__text">Drag and Drop files here or <em>browse</em></div>
    </el-upload>
    <div class="rp-messenger-drag-drop-file-uploader-file-list" v-if="fileListLatest.length">
        <DocumentItem
            v-for="(file, index) in fileListLatest"
            :key="file.name + index"
            @removeFile="removeFile"
            @retryFailedFile="retryFailedFile"
            :file="file" />
    </div>
</div>
</template>
<script>
// import DocumentItem from './documentItem';
import File from './../../../models/File';
import DocumentItem from './../DocumentItem';

export default {
    components: {
        DocumentItem,
    },

    props: {
        filesList: {
            type: Array,
            default: []
        },
    },

    data() {
        return {
            fileList: this.filesList,
            fileListLatest: this.filesList,
        }
    },

    methods : {
        handleRemove() {
            this.$emit('handleRemove')   
        },

        handleSuccess(e, f, l) {
            f.url = f.response.data.fileUpload;
            this.$emit('filesUploaded', l)
        },

        handleProgress(e, f, l) {
            if(f.status==='fail') {
                console.log(f)
                // this.fileListLatest.findIndex(f.)
            } else {
                this.fileListLatest = l;
            }
        },

        handleError(e, f, l) {
            console.log("errored", l)
            if(f.status === 'fail') {
                this.fileListLatest.push(f)
            }
            // console.log(e, f, l)
        },

        async removeFile(file) {
            
            if(file.status === 'uploading')
                this.$refs['rp-uplod-files'].abort(file)
            
            await File.delete([file.url]);
            this.fileListLatest.splice(
                this.fileListLatest.findIndex(fil => file.url == fil.url), 1
            )
            this.$emit('filesUploaded', this.fileListLatest)
        },

        retryFailedFile(file) {
            if(file.status === 'fail') {
                file.status = 'ready';
                file.percentage = 0;
                this.$refs['rp-uplod-files'].submit()
            }
        },

        getUrl() {
            return File.getUploadUrl()
        },

        getUploadProps() {
            return File.getUploadProps();
        },

        dragAndDropEvent(e, type) {
            if(e.target && e.target.lastElementChild && e.target.lastElementChild.className !== 'rp-drag-drop-file-uploader__text') {
                let element = this.$refs['rpUplodFiles']
                if(type === 'over') {
                    element.$refs["upload-inner"].$children["0"].onDragover(e)
                } else if(type === 'drop') {
                    element.$refs["upload-inner"].$children["0"].onDrop(e)
                } else if(type === 'leave') {
                    element.$refs["upload-inner"].$children["0"].dragover = false;
                }
            }
        }

    }
}
</script>
<style lang="scss">

    .rp-messenger-drag-drop-file-uploader-file-list {
        margin-top: 1rem;
        width: 95%;
    }
    .rp-messenger-drag-drop-file-uploader {
        display: flex;
        flex-direction: column-reverse;
        .el-upload {
            width: 100%;
        }
        .el-upload-dragger {
            border: 1px dashed #cccccc;
            background: #fcfcfc;
            padding: 1rem !important;
            width: 100%;
            height: 100%;

            &:hover {
                border-color: var(--theme-background-color);
            }
            &.is-dragover {
                background-color: rgba(var(--theme-background-color), 0.11);
                border-color: var(--theme-background-color);
            }

            .el-icon-bottom {
                font-size: 1rem;
                margin: 0rem;
                line-height: normal;
                color: #a1a1a1;
                border: 1px dotted #dcdcdc;
                padding: 4px;
            }
            .rp-drag-drop-file-uploader__text {
                margin-top: 0.5rem;
                color: #666666;
                font-size: 14px;
                font-weight: 300;
                em {
                    text-decoration: underline;
                    font-style: normal;
                    color: #333333;
                    font-weight: 400;
                }
            }
        }

    }
</style>